var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Magnifier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.805,8.906c-1.322-1.322-3.08-2.05-4.95-2.05s-3.627,0.728-4.95,2.05c-2.729,2.729-2.729,7.17,0,9.9    c1.323,1.322,3.081,2.049,4.95,2.049s3.627-0.728,4.949-2.05C21.534,16.076,21.534,11.635,18.805,8.906z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.723,23.836l-4.717-3.871c2.812-4.634,2.132-10.59-1.771-14.492C19.996,3.233,17.019,2,13.853,2    S7.711,3.232,5.472,5.472c-2.24,2.239-3.473,5.216-3.473,8.382s1.233,6.143,3.473,8.382c2.302,2.302,5.33,3.483,8.379,3.483    c2.091,0,4.193-0.556,6.078-1.686l3.905,4.689c0.656,0.806,1.654,1.281,2.692,1.28c0.916,0,1.803-0.364,2.463-1.018    c0.691-0.698,1.059-1.66,1.007-2.639C29.944,25.368,29.48,24.453,28.723,23.836z M8.906,18.806c-2.729-2.73-2.729-7.171,0-9.9    c1.322-1.322,3.08-2.05,4.95-2.05s3.627,0.728,4.95,2.05c2.729,2.729,2.729,7.17,0,9.9c-1.322,1.322-3.08,2.05-4.949,2.05    C11.987,20.855,10.229,20.128,8.906,18.806z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e1f047b2eb6ffe28468726d8e603e074.svg";
export { ForwardRef as ReactComponent };